import { useSelector, shallowEqual } from 'react-redux'
import { Stack, Button, Spinner } from '@leroy-merlin-br/backyard-react-ui'

import { formatters } from 'reactUtils/formatters'

import { Step } from '../../components/Step'
import * as S from './styled'

const ConcludeMobile = ({
  currentStep,
  customerSelected,
  onClose,
  onClick,
  price
}) => {
  const { payload } = useSelector((state) => state.user.get, shallowEqual)
  const { isRequest } = useSelector((state) => state.coupon.shareable)

  return (
    <Step step={3} currentStep={currentStep}>
      <S.Overlay />
      <S.Container>
        <S.Title>
          Tem certeza que deseja compartilhar esse cupom com{' '}
          {customerSelected && customerSelected.customerName} por{' '}
          <strong>{formatters.toDecimal(price)} pts?</strong>
        </S.Title>

        <S.Description as="p" noMargin>
          Seu Saldo atual é de{' '}
          <strong>{formatters.toDecimal(payload.points.actual)} pts</strong>.
        </S.Description>

        <S.ContainerFooter>
          <Stack spacing="kilo">
            <Button color="green" onClick={onClick} isLoading={isRequest}>
              {isRequest ? <Spinner /> : `${formatters.toDecimal(price)} Pts`}
            </Button>

            <Button
              color="green"
              variant="ghost"
              onClick={onClose}
              isDisabled={isRequest}
            >
              voltar
            </Button>
          </Stack>
        </S.ContainerFooter>
      </S.Container>
    </Step>
  )
}

export default ConcludeMobile
